import { renderStatus } from 'pages/Workshop/Forms/components/FormsTable';
import styles from './style.module.scss';
import { FormsTableStatus } from 'app-constants';

export const StatusColumn = ({ row: { status } }) => {
  return renderStatus(status, `${styles.formStatus}`);
};
